import { render, staticRenderFns } from "./BDPView.vue?vue&type=template&id=60777fc0&"
import script from "./BDPView.vue?vue&type=script&lang=js&"
export * from "./BDPView.vue?vue&type=script&lang=js&"
import style0 from "./BDPView.vue?vue&type=style&index=0&id=60777fc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports